import React, {createContext, useState} from "react";
import styled from "styled-components";
import {MainWidget} from "./main_list_widget";
import {Route, Switch, NavLink, Redirect} from "react-router-dom";
import {MainMyWidget} from "./main_my_widget";
import {TopWidget} from "../widget/top_widget";
import {HttpServer} from "../../../net/http_server";

export const ListWidget: React.FC = () => {
    const [topData, setTopData] = useState();
    return (
        <ClaimsProvider.Provider value={{setTopData,topData}}>
            <TopWidget />
            <WapStyle>
                <h2 className={"title"}>
                    <TabCellStyle to={'/claims/list/claims'}>Claims</TabCellStyle>
                    <TabCellStyle to={'/claims/list/down'}>My Applications</TabCellStyle>
                </h2>
                <Switch>
                    <Route path="/claims/list/claims" exact ><MainWidget/></Route>
                    <Route path="/claims/list/down" exact>
                        <MainMyWidget />
                    </Route>
                    <Redirect to="/claims/list/claims"/>
                </Switch>

            </WapStyle>
        </ClaimsProvider.Provider>
    );
}



export const ClaimsProvider = createContext<{ setTopData: Function ,topData:any}>({setTopData: () => null,topData:{}});

const TabCellStyle = styled(NavLink)`
  height: 50px;
  border-radius: 10px 10px 0 0;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  text-decoration: none;
  font-weight: 400;
  cursor: pointer;
  padding: 0 30px;
  color: #222222;
  font-size: 16px;

  &.active {
    background: #E4EEFD;
    transform: translate(0, 0px);
  }

`;

const WapStyle = styled.div`
  margin-top: 40px;
  background-color: white;
  border-radius: 10px;

  .title {
    height: 50px;
    display: flex;
    align-items: center;

    span {

    }
  }
`
